module.exports = __webpack_public_path__ + "img/212-Blanc Veiné.jpg";